import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-login-button',
  templateUrl: './login-button.component.html',
  standalone: true,
  imports: [NgTemplateOutlet],
})
export class LoginButtonComponent {
  readonly click = input<(this: GlobalEventHandlers, ev: MouseEvent) => void>();
  readonly href = input<string>();
  readonly class =
    'w-full bg-white text-blue-600 py-3 px-6 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-blue-50 transition-all duration-300 cursor-pointer';
}
